import { createAction } from '@reduxjs/toolkit';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';

export class CreateMessageFailure {
  static get action() {
    return createAction('broadcastMessages/CREATE_MESSAGE_FAILURE');
  }

  static get reducer() {
    return (draft: IBroadcastMessagesState) => {
      draft.requests.createBroadcastMessagePending = false;
      return draft;
    };
  }
}
